/**
 * Generated by orval v7.8.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

/**
 * Status of an activity revision
 */
export enum ActivityRevisionStatus {
  pending = 'pending',
  approved = 'approved',
  declined = 'declined'
}
